import { render, staticRenderFns } from "./endorsementPane.vue?vue&type=template&id=0819644c"
import script from "./endorsementPane.vue?vue&type=script&lang=js"
export * from "./endorsementPane.vue?vue&type=script&lang=js"
import style0 from "./endorsementPane.vue?vue&type=style&index=0&id=0819644c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports